export {
  configureLegacyApplication,
  container,
  getLegacyBindingContext,
  graphicService,
  graphicUtil,
  layerService,
  preLoadAllModule,
  transformUtil
} from './modules';
export type { ILegacyBindContext, ILegacyBindingContext } from './legacy/bootstrap';
